module.exports = __webpack_public_path__ + "static/media/dungeon_floor_nw2.73826d0a.png";